import {
  Typography,
  TypographyVariants,
  TypographyColors,
  TypographyElements,
} from '@carboledger/ui';
import { useTranslations } from '@/hooks';
import styles from './LoadingOverlay.module.scss';

/**
 * Props:
 *   label       what is loading; defaults to the shared "Loading…" copy
 *   fullscreen  cover the viewport instead of sitting inline
 */
export const LoadingOverlay = ({ label, fullscreen = false }) => {
  const t = useTranslations();

  return (
    <div
      className={fullscreen ? styles.fullscreen : styles.inline}
      role="status"
      aria-live="polite"
    >
      <span className={styles.spinner} aria-hidden="true" />
      <Typography
        as={TypographyElements.span}
        variant={TypographyVariants.bodySm}
        color={TypographyColors.secondary}
      >
        {label ?? t('COMMON_LOADING')}
      </Typography>
    </div>
  );
};
